import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PROVIDER_SESSIONS_GET_MANY, StateStatus } from '@guryou/redux';
import { resetState } from '../actions';
import { getSessionsByClassId, resetSessionState } from '../new/session';
const useSessions = classId => {
  const dispatch = useDispatch();
  const {
    data,
    status,
    version,
    entity,
    request
  } = useSelector(state => state.sessions.all);
  const sessionCreate = useSelector(state => state.sessions.create);
  const sessionUpdate = useSelector(state => state.sessions.update);
  const sessionDelete = useSelector(state => state.sessions.delete);
  useEffect(() => {
    return () => resetState(PROVIDER_SESSIONS_GET_MANY);
  }, []);
  useEffect(() => {
    if (sessionCreate.version || sessionUpdate.version || sessionDelete.version) {
      dispatch(resetSessionState());
      dispatch(getSessionsByClassId(classId, true));
    }
  }, [dispatch, classId, sessionCreate.version, sessionUpdate.version, sessionDelete.version]);
  useEffect(() => {
    if (!classId) {
      return;
    }
    if (status === StateStatus.NOT_INITIALIZED || status === StateStatus.LOADED && request.classId !== classId) {
      dispatch(getSessionsByClassId(classId));
    }
  }, [classId, data, dispatch, request, status]);
  if (!classId) {
    return {
      data: null,
      status: StateStatus.NOT_INITIALIZED
    };
  }
  return {
    data: data || [],
    status,
    version,
    entity
  };
};
export default useSessions;